module.exports = __webpack_public_path__ + "img/multiple_pdfs_windows.25c4004b.png";